import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { Store } from './types';

type Props = {
  place: google.maps.places.PlaceResult | null;
  store: Store | null;
};

const MapHandler = ({ place, store }: Props) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !place) return;

    if (place.geometry?.viewport) {
      map.fitBounds(place.geometry?.viewport);
    }
  }, [map, place]);

  useEffect(() => {
    if (!map || !store) return;

    map.setZoom(12);
    map.panTo({ lat: store.lat, lng: store.lng });
  }, [map, store]);

  return null;
};

export default MapHandler;
